/* ── Formatters ── */
import { getCurrencySymbol } from "../../../utils/currency";

const locale = typeof navigator !== "undefined" ? navigator.language : "en-US";

export const fmtNumber = (v, d = 2) =>
  v === null || v === undefined || isNaN(Number(v))
    ? "—"
    : Number(v).toLocaleString(locale, { minimumFractionDigits: d, maximumFractionDigits: d });

export const fmtPercent = (v, d = 2) =>
  v === null || v === undefined || isNaN(Number(v))
    ? "—"
    : `${Number(v) >= 0 ? "+" : ""}${fmtNumber(v, d)}%`;
/** Color helper: green for positive, red for negative, muted for null/zero */

export const fmtCurrency = (v, d = 2, compact = false) => {
  if (v === null || v === undefined || isNaN(Number(v))) return "—";
  const sym = getCurrencySymbol();
  const num = Number(v);
  if (compact) {
    const abs = Math.abs(num);
    const sign = num < 0 ? "-" : "";
    if (abs >= 1e12) return `${sign}${sym}${fmtNumber(abs / 1e12, d)}T`;
    if (abs >= 1e9) return `${sign}${sym}${fmtNumber(abs / 1e9, d)}B`;
    if (abs >= 1e6) return `${sign}${sym}${fmtNumber(abs / 1e6, d)}M`;
    if (abs >= 1e3) return `${sign}${sym}${fmtNumber(abs / 1e3, d)}K`;
    return `${sign}${sym}${fmtNumber(abs, d)}`;
  }
  return `${sym}${fmtNumber(v, d)}`;
};

/** Format a gain/loss value with explicit +/- prefix for accessibility (3.1.1) */
export const fmtGain = (v, d = 2) => {
  if (v === null || v === undefined || isNaN(Number(v))) return "—";
  const n = Number(v);
  const sign = n >= 0 ? "+" : "";
  return `${sign}${fmtNumber(v, d)}`;
};

export const gainColor = (v) => {
  if (v === null || v === undefined) return "var(--color-text-secondary)";
  const n = Number(v);
  if (isNaN(n)) return "var(--color-text-secondary)";
  if (n > 0) return "var(--color-success)";
  if (n < 0) return "var(--color-error)";
  return "var(--color-text-secondary)";
};

export const gradeColor = (g) => {
  if (!g || g === "N/A" || g === "—") return "var(--color-text-muted)";
  const l = g.charAt(0).toUpperCase();
  if (l === "A") return "#15803d";
  if (l === "B") return "#84CC16";
  if (l === "C") return "#eab308";
  if (l === "D") return "#ef4444";
  return "#dc2626";
};

/* ── Constants ── */
export const COLORS = [
  "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6",
  "#ec4899", "#06b6d4", "#84cc16", "#f97316", "#6366f1",
];

export const RATING_CATEGORIES = [
  { key: "Strong Buy", color: "#15803d" },
  { key: "Buy", color: "#84CC16" },
  { key: "Hold", color: "#eab308" },
  { key: "Sell", color: "#ef4444" },
  { key: "Strong Sell", color: "#dc2626" },
  { key: "Not Covered", color: "#9ca3af" },
];